// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-trade-point-brochure/form-item-trade-point-brochure.component.scss
// module id = 979
// module chunks = 0